import { useState, useEffect } from 'react'

interface CountdownResult {
  hours: string
  minutes: string
  seconds: string
}

export function useCountdown(
  initialHours: number,
  initialMinutes: number,
  initialSeconds: number,
): CountdownResult {
  const [timeLeft, setTimeLeft] = useState(() => {
    const savedEndTime = localStorage.getItem('reinicio40_countdown_end')

    if (savedEndTime) {
      const remaining = Math.max(0, parseInt(savedEndTime, 10) - Date.now())
      if (remaining > 0) return remaining
    }

    const initialTotalMs =
      (initialHours * 3600 + initialMinutes * 60 + initialSeconds) * 1000
    const endTime = Date.now() + initialTotalMs
    localStorage.setItem('reinicio40_countdown_end', endTime.toString())
    return initialTotalMs
  })

  useEffect(() => {
    if (timeLeft <= 0) return

    const intervalId = setInterval(() => {
      setTimeLeft((prev) => {
        const newTime = prev - 1000
        if (newTime <= 0) {
          clearInterval(intervalId)
          return 0
        }
        return newTime
      })
    }, 1000)

    return () => clearInterval(intervalId)
  }, [timeLeft])

  const h = Math.floor(timeLeft / (1000 * 60 * 60))
  const m = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))
  const s = Math.floor((timeLeft % (1000 * 60)) / 1000)

  return {
    hours: h.toString().padStart(2, '0'),
    minutes: m.toString().padStart(2, '0'),
    seconds: s.toString().padStart(2, '0'),
  }
}
